module.exports = __webpack_public_path__ + "static/media/background-remover-mobile.c470360c.png";